ScoreTrekBattle.Tournament.List = (function() {
    var _this, CONFIG, STATUS, CACHE;

    CONFIG = {
        STORAGE_KEY: 'ScoreTrekBattle.Tournament.List.Cache',
        CACHE_SIZE: 5,
        FOCUS_PREFIX: 'focus:',
        PATH_ORDER: ['locationCity', 'clubId', 'leagueLimit'],
        PATH_PLACEHOLDER: '-'
    };

    CACHE = {};

    function resetStatus() {
        STATUS = {
            active: false,
            isLoading: false,
            isScrolling: false,
            isFiltersLoaded: false,
            isRendering: false,
            fallback: null,
            view: null,
            $view: null,
            $list: null,
            $loadMore: null,
            focusTournamentId: null,
            observer: null,
            config: {},
            options: {},
            isAscending: true,
            viewId: '',
            pathArgs: [],
            filtersPromise: Promise.resolve(),
            FILTERS: [],
            CURRENT: {}
        };

        ScoreTrekBattle.Series.setCurrent(null);
        ScoreTrekBattle.Club.setCurrent(null);
    }
    resetStatus();

    function initCache(key, subKey) {
        if (CACHE.hasOwnProperty(key) && CACHE[key].index.hasOwnProperty(subKey)) {
            return;
        }

        CACHE[key] = CACHE[key] || {
            index: {},
            cache: []
        };

        CACHE[key].cache.push({
            subKey: subKey,
            filters: {},
            scrollTop: 0,
            offset: 0,
            now: 0,
            items: [],
            hasMore: false,
            timestamp: 0,
            isStale: false
        });
        CACHE[key].index[subKey] = CACHE[key].cache.length - 1;

        // limit cache size
        while (CACHE[key].cache.length > CONFIG.CACHE_SIZE) {
            CACHE[key].cache.shift();
        }

        CACHE[key].index = {};

        CACHE[key].cache.forEach((cacheItem, index) => {
            CACHE[key].index[cacheItem.subKey] = index;
        });

        storeCache();
    }

    function resetCacheItem(cacheItem) {
        cacheItem.scrollTop = 0;
        cacheItem.offset = 0;
        cacheItem.now = 0;
        cacheItem.items = [];
        cacheItem.hasMore = false;
        cacheItem.timestamp = 0;
        cacheItem.isStale = false;
    }

    function getCache(key, subKey) {
        initCache(key, subKey);

        return CACHE[key].cache[CACHE[key].index[subKey]];
    }

    function loadCache() {
        let storeData;
        
        try {
            storeData = JSON.parse(sessionStorage.getItem(CONFIG.STORAGE_KEY));
        } catch (error) {
            storeData = null;
        }

        if (storeData) {
            CACHE = storeData;
        }
    }
    loadCache();

    function storeCache() {
        let storeData;
        
        storeData = DataHandler.cloneObject(CACHE);

        Object.keys(storeData).forEach(key => {
            storeData[key].cache.forEach(cacheItem => {
                resetCacheItem(cacheItem);
            });
        });

        sessionStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify(storeData));
    }

    function storeScrollTop(scrollTop) {
        let offset;
        
        if (!STATUS.$view || STATUS.isScrolling) {
            return;
        }

        offset = 0;

        if (STATUS.$view.find('[data-id="filters"]').hasClass('isOpen')) {
            offset = STATUS.$view.find('[data-id="filtersContent"]').outerHeight() || 0;
        }

        STATUS.CURRENT.scrollTop = scrollTop - offset;
        storeCache();
    }

    function resetFilters() {
        STATUS.CURRENT.filters = {};

        resetCacheItem(STATUS.CURRENT);

        updateFilters();
        updatePath();

        storeCache();

        updateList();
    }

    function toggleFilters(isOpen) {
        if (!STATUS.$view) {
            return;
        }

        STATUS.filtersLockedUntil = Infinity;

        STATUS.$view.find('[data-id="filters"]').toggleClass('isOpen', isOpen);
        STATUS.$view.find('[data-id="filtersContent"]').stop()[isOpen ? 'slideDown' : 'slideUp'](200, function() {
            STATUS.filtersLockedUntil = Date.now() + 300;
        });
    }

    function isFiltersToggleLocked() {
        return Date.now() < (STATUS.filtersLockedUntil || 0);
    }

    function isFiltersObstructive() {
        let $filters, rect;

        $filters = STATUS.$view.find('[data-id="filters"]');

        if (!$filters.hasClass('isOpen')) {
            return false;
        }

        rect = $filters[0].getBoundingClientRect();

        return rect.height > ((window.innerHeight - ScoreTrekBattle.View.getViewportInsets().bottom - rect.top) / 3);
    }

    function initFilters() {
        let $filters, $filtersContent;

        if (!STATUS.$view) {
            return;
        }

        $filters = STATUS.$view.find('[data-id="filters"]');
        $filtersContent = STATUS.$view.find('[data-id="filtersContent"]');

        if ($filters.length === 0) {
            return;
        }

        STATUS.isFiltersLoaded = false;

        $filtersContent.addClass('loading');

        return loadFilters().then(() => {
            if (!STATUS.$view) {
                return;
            }

            STATUS.isFiltersLoaded = true;
            $filters.css('display', '');

            Object.values(STATUS.view.controls).forEach(control => {
                let filterKey, filterType;

                filterKey = control.$view[0].dataset.filter;
                filterType = control.$view[0].dataset.filterType;

                if (!filterKey || !filterType) {
                    return;
                }

                if (filterType === 'list') {
                    control.setOptions(formatFilterOptions(filterKey, STATUS.FILTERS[filterKey].values || {}), {'': `-- ${__i18n('filter/all')} --`});
                } else {
                    console.warn(`Unknown filter type: ${filterType}`);
                }

                control.on('change', changeFilter);
            });

            if (STATUS.pathArgs.length > 0) {
                applyPathFilters(STATUS.pathArgs);
                STATUS.pathArgs = [];
            }
        }).catch(error => {
            console.warn(error);
            $filters.css('display', 'none');
        }).finally(() => {
            $filtersContent.removeClass('loading');
            updateFilters();
            indicateFilters();
            updatePath();
        });
    }

    function applyPathFilters(pathArgs) {
        let filters;

        filters = {};

        CONFIG.PATH_ORDER.forEach((filterKey, index) => {
            let segment, value;

            segment = pathArgs[index] || '';

            if (!segment || (segment === CONFIG.PATH_PLACEHOLDER)) {
                return;
            }

            value = Object.keys(getFilterOptions(filterKey)).find(optionValue => {
                return (getOptionSlug(filterKey, optionValue) === segment);
            });

            if (value) {
                filters[filterKey] = value;
            }
        });

        STATUS.CURRENT.filters = filters;

        resetCacheItem(STATUS.CURRENT);
        storeCache();
    }

    function getFilterOptions(filterKey) {
        let values;

        values = (STATUS.FILTERS[filterKey] && STATUS.FILTERS[filterKey].values) || {};

        if (filterKey === 'clubId') {
            return Object.assign({}, ...Object.values(values));
        }

        return values;
    }

    function getOptionSlug(filterKey, value) {
        let option;

        if (filterKey === 'clubId') {
            option = getFilterOptions(filterKey)[value];

            return (option && option.slug) ? String(option.slug) : '';
        }

        return String(value || '').toLowerCase()
            .replace(/ä/g, 'ae')
            .replace(/ö/g, 'oe')
            .replace(/ü/g, 'ue')
            .replace(/ß/g, 'ss')
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    function updatePath() {
        if (!STATUS.viewId || !STATUS.isFiltersLoaded) {
            return;
        }

        ScoreTrekBattle.View.setPath(buildPath());
    }

    function buildPath() {
        let filters, segments, placeholders;

        filters = STATUS.CURRENT.filters || {};
        segments = [];
        placeholders = [];

        CONFIG.PATH_ORDER.forEach(filterKey => {
            let slug;

            slug = filters[filterKey] ? getOptionSlug(filterKey, filters[filterKey]) : '';

            if (!slug) {
                placeholders.push(CONFIG.PATH_PLACEHOLDER);
                return;
            }

            segments = segments.concat(placeholders, [slug]);
            placeholders = [];
        });

        return STATUS.viewId + (segments.length ? `/${segments.join('/')}` : '');
    }

    function getShareName() {
        let title, names;

        title = __i18n(STATUS.config.title);

        names = CONFIG.PATH_ORDER.filter(filterKey => {
            return !!(STATUS.CURRENT.filters || {})[filterKey] && !!STATUS.view.controls[filterKey];
        }).map(filterKey => {
            return STATUS.view.controls[filterKey].getText();
        });

        if (names.length === 0) {
            return title;
        }

        return __i18n('share/name/tournamentsOf', {list: title, name: names.join(' · ')});
    }

    function collectPathArgs(args) {
        return Array.prototype.slice.call(args).filter(segment => {
            return (String(segment || '').trim() !== '') && !String(segment).startsWith(CONFIG.FOCUS_PREFIX);
        });
    }

    function hasPathArguments() {
        return !!(STATUS.viewId || STATUS.config.seriesId || STATUS.config.clubId);
    }

    function getFocusTournamentId(args) {
        let segment;

        segment = Array.prototype.slice.call(args).find(segment => {
            return String(segment || '').startsWith(CONFIG.FOCUS_PREFIX);
        });

        return segment ? String(segment).substr(CONFIG.FOCUS_PREFIX.length) : '';
    }

    function formatFilterOptions(filterKey, values) {
        let renderedValues;

        if (filterKey === 'clubId') {
            renderedValues = [];

            Object.keys(values).forEach(group => {
                let groupValues;

                groupValues = {
                    label: __i18n(`filter/clubType/${group}`),
                    options: {}
                };

                Object.keys(values[group]).forEach(key => {
                    let value;

                    value = values[group][key];

                    groupValues.options[key] = {
                        text: value.text,
                        $html: renderFilterOptionClub(value.data)
                    };
                });

                renderedValues.push(groupValues);
            });

            return renderedValues;
        }

        return values;
    }

    function renderFilterOptionClub(club) {
        return $([
            `<span class="club-select-item">`,
                `<span class="club-select-item-image" style="background-image:url('${club.logo}')"></span>`,
                `<span class="club-select-item-details">`,
                    `<span class="club-select-item-details-name">${club.name}</span>`,
                    `<span class="club-select-item-details-location">${club.address.zip} ${club.address.city}</span>`,
                `</span>`,
            `</span>`
        ].join(''));
    }

    function loadFilters() {
        return new Promise(function(resolve, reject) {
            Api.request('/battle/tournament/filters', {}).then(result => {
                if (!result || !result.filters) {
                    return reject();
                }

                STATUS.FILTERS = result.filters;

                if (STATUS.FILTERS.leagueLimit && STATUS.FILTERS.leagueLimit.values) {
                    Object.keys(STATUS.FILTERS.leagueLimit.values).forEach(filterKey => {
                        STATUS.FILTERS.leagueLimit.values[filterKey] = __i18n(`form/options/leagueLimit/${filterKey}`);
                    });
                }

                resolve();
            }).catch(reject);
        });
    }

    function updateFilters() {
        if (!STATUS.$view || !STATUS.isFiltersLoaded) {
            return;
        }

        Object.values(STATUS.view.controls).forEach(control => {
            let filterKey, filterType;

            filterKey = control.$view[0].dataset.filter;
            filterType = control.$view[0].dataset.filterType;

            if (!filterKey || !filterType) {
                return;
            }

            if (filterType === 'list') {
                control.set(STATUS.CURRENT.filters[filterKey] || null);
            }
        });
    }

    function indicateFilters() {
        let filterCount;

        if (!STATUS.$view) {
            return;
        }

        filterCount = Object.keys(STATUS.CURRENT.filters || {}).length;

        STATUS.$view.attr('data-has-filters', filterCount ? 'yes' : 'no');
        STATUS.$view.find('[data-id="filterCount"]').text(filterCount);
    }

    function changeFilter() {
        let filterKey, filterType, filterValue;

        filterKey = this.$view[0].dataset.filter;
        filterType = this.$view[0].dataset.filterType;

        if (!filterKey || !filterType) {
            return;
        }

        if (filterType === 'list') {
            filterValue = String(this.get()).trim();
        } else {
            console.warn(`Unknown filter type: ${filterType}`);
        }

        if (filterValue) {
            STATUS.CURRENT.filters[filterKey] = filterValue;
        } else {
            delete STATUS.CURRENT.filters[filterKey];
        }

        resetCacheItem(STATUS.CURRENT);

        updatePath();

        storeCache();

        updateList();
    }

    function getStatusParameter(tournamentStatus) {
        if (tournamentStatus === 'running') {
            return ['starting', 'running', 'done'];
        }

        if (tournamentStatus === 'scheduled') {
            return ['scheduled', 'starting', 'running', 'done'];
        }

        if (tournamentStatus === 'sealed') {
            return ['annulled', 'done'];
        }
    }

    function onViewRender(tournamentStatus, isMine, refId, cacheKey, viewId, pathArgs) {
        return new Promise(function(resolve) {
            var isFinalized, useStatus, isPlan, isClub, isDesc, tabsTemplate;

            isFinalized = (tournamentStatus === 'sealed');
            isPlan = (tournamentStatus === 'plan');
            isClub = (tournamentStatus === 'club');

            useStatus = isFinalized ? 'done' : tournamentStatus;

            isDesc = ((tournamentStatus === 'running') || isFinalized || isMine || isClub || isPlan);

            STATUS.CURRENT = getCache(cacheKey, refId || '');

            STATUS.isAscending = !isDesc;

            STATUS.viewId = viewId || '';
            STATUS.pathArgs = pathArgs || [];

            stopObserver();

            STATUS.config = {
                isPlan: isPlan,
                status: getStatusParameter(tournamentStatus) || useStatus,
                isFinalized: isFinalized,
                isMine: isMine,
                seriesId: (tournamentStatus === 'series') ? refId : '',
                isClub: isClub,
                clubId: isClub ? refId : '',
                icon: `tournament/list/${isMine ? 'my' : useStatus}/icon`,
                title: `tournament/list/${isMine ? 'my' : useStatus}/title`,
                intro: `tournament/list/${isMine ? 'my' : useStatus}/intro`,
                sort: {
                    dateTimeTournament: isDesc ? false : true,
                    title: true
                }
            };

            if (isPlan || isClub) {
                STATUS.config.status = ['scheduled', 'annulled', 'starting', 'running', 'done'];
                STATUS.config.sort = {
                    dateTimeTournament: false,
                    title: true
                };
            }

            tabsTemplate = isMine ? 'tournament/nav/tabsFavorites' : 'tournament/nav/tabsPlan';

            ScoreTrekBattle.View.updateMenu(ScoreTrekBattle.Tournament.getMenuLink(isMine ? 'my' : tournamentStatus));
            ScoreTrekBattle.Template.renderMulti([
                tabsTemplate,
                'tournament/list'
            ], {
                'tournament/list': {
                    config: STATUS.config
                }
            }).then(views => {
                var $tabs;

                STATUS.active = true;
                STATUS.view = views['tournament/list'];
                STATUS.$view = STATUS.view.$view;
                STATUS.$list = STATUS.$view.find('[data-id="list"]');
                STATUS.$loadMore = STATUS.$view.find('[data-id="loadMore"]');
                STATUS.observer = LazyLoadObserver(STATUS.$loadMore[0], loadMore, {margin: window.innerHeight});

                $tabs = views[tabsTemplate].$view;
                $tabs.find('[data-tab="tournament"]').addClass('isActive');
                $tabs.find(`[data-tab="tournaments"]`).addClass('isActive');

                STATUS.$view.attr('data-has-filters', 'no');
                STATUS.$view.find('[data-id="filterCount"]').text('0');
                STATUS.$view.find('[data-id="filtersContent"]').hide();

                if (!STATUS.viewId) {
                    STATUS.$view.find('[data-id="filters"]').remove();
                }

                STATUS.filtersPromise = Promise.resolve(initFilters());

                updateFilters();

                indicateFilters();

                if (!STATUS.config.isPlan) {
                    STATUS.$view.find('[data-ref-id="tournamentPlan"]').remove();
                }

                resolve((STATUS.config.isPlan || isMine) ? $tabs.add(STATUS.$view) : STATUS.$view);
            });
        });
    }

    function onViewLoad(tournamentId) {
        return new Promise(function(resolve) {
            STATUS.active = true;

            STATUS.fallback = (String(tournamentId).substr(0, 9) === 'fallback:') ? tournamentId : null;

            if (STATUS.fallback) {
                tournamentId = '';
            }

            if (hasPathArguments()) {
                tournamentId = getFocusTournamentId(arguments);
            }

            updateClub().then(() => {
                updateSeries().then(() => {
                    toggleReadMore(checkReadMore());

                    (STATUS.pathArgs.length ? STATUS.filtersPromise : Promise.resolve()).then(() => {
                        if (!STATUS.$list) {
                            return;
                        }

                        updateList(tournamentId, true);
                    });
                }).catch(ignore => {}).finally(() => {
                    resolve();
                });
            }).catch(ignore => {}).finally(() => {
                resolve();
            });
        });
    }

    function onViewUpdate(tournamentId) {
        let pathArgs;

        pathArgs = STATUS.viewId ? collectPathArgs(arguments) : [];

        if (hasPathArguments()) {
            tournamentId = getFocusTournamentId(arguments);
        }

        return new Promise(function(resolve) {
            if (STATUS.viewId && !STATUS.isFiltersLoaded && (pathArgs.length > 0)) {
                STATUS.pathArgs = pathArgs;

                STATUS.filtersPromise.then(() => {
                    if (!STATUS.$list) {
                        return;
                    }

                    updateList(tournamentId);
                });

                return resolve();
            }

            setTimeout(() => {
                if (!STATUS.$list) {
                    return;
                }

                if (STATUS.viewId && STATUS.isFiltersLoaded) {
                    if (pathArgs.length > 0) {
                        applyPathFilters(pathArgs);
                        updateFilters();
                        indicateFilters();
                    }

                    updatePath();
                }

                updateList(tournamentId);
            }, 0);
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            storeScrollTop(AnimationHandler.getScrollTop());
            stopObserver();
            resetStatus();
            resolve();
        });
    }

    function startObserver() {
        if (STATUS.observer) {
            STATUS.observer.start();
        }
    }

    function stopObserver() {
        if (STATUS.observer) {
            STATUS.observer.stop();
        }
    }

    function checkReadMore() {
        var $wrapper, $description, hasReadMore;

        if (!STATUS.$view) {
            return;
        }

        $description = STATUS.$view.find('[data-id="description"]');
        $wrapper = STATUS.$view.find('[data-id="descriptionWrapper"]');

        $description.stop();

        $wrapper.addClass('hasReadMore').removeClass('hasReadLess');
        resetReadMore();

        hasReadMore = ($description.outerHeight() > ($wrapper.height() + 1));

        $wrapper.toggleClass('hasReadLess', hasReadMore);

        return hasReadMore;
    }

    function toggleReadMore(hasReadMore) {
        var $wrapper, $description, startHeight, endHeight;

        if (!STATUS.$view) {
            return;
        }

        $description = STATUS.$view.find('[data-id="description"]');
        $wrapper = STATUS.$view.find('[data-id="descriptionWrapper"]');

        if (hasReadMore === $wrapper.hasClass('hasReadMore')) {
            return;
        }

        if (hasReadMore) {
            startHeight = $description.height();
            $wrapper.addClass('hasReadMore');
            endHeight = $wrapper.height();
        } else {
            startHeight = $wrapper.height();
            endHeight = $description.css('height', '').height();
            $wrapper.removeClass('hasReadMore');
        }

        $wrapper.css('max-height', 'none');
        $description.css({
            'height': `${startHeight}px`,
            'overflow': 'hidden'
        }).stop().animate({
            height: `${endHeight}px`
        }, 400, function() {
            resetReadMore();
        });
    }

    function resetReadMore() {
        if (!STATUS.$view) {
            return;
        }

        STATUS.$view.find('[data-id="descriptionWrapper"]').stop().css('max-height', '');
        STATUS.$view.find('[data-id="description"]').stop().css({
            'height': '',
            'overflow': ''
        });
    }

    $(window).on('resize', () => {
        toggleReadMore(checkReadMore());
    });

    function updateSeries() {
        return new Promise(function(resolve, reject) {
            if (!STATUS.config.seriesId) {
                STATUS.$view.find('[data-ref-id="tournamentSeries"]').remove();
                resolve();
                return;
            }

            ScoreTrekBattle.View.loadingBackground('Tournament.List.updateSeries', true);

            loadSeries().then(result => {
                let series, ranking;

                series = result.series;
                ranking = result.ranking;

                ScoreTrekBattle.Series.setCurrent(series);

                ScoreTrekBattle.Template.renderMulti([
                    'tournament/series/rankingHeader',
                    'tournament/series/ranking'
                ]).then(views => {
                    STATUS.$view.find('[data-id="seriesRankings"]').append(views['tournament/series/rankingHeader'].$view);

                    ScoreTrekBattle.Template.render('tournament/series/ranking').then(view => {
                        let rankingPromises, positionCounts;

                        if (ranking.length === 0) {
                            STATUS.$view.find('[data-id="seriesRanking"]').hide();
                            return;
                        }

                        rankingPromises = [];
                        positionCounts = {};

                        ranking.forEach(rankingItem => {
                            positionCounts[rankingItem.position] = (positionCounts[rankingItem.position] || 0) + 1;
                        });

                        ranking.forEach(rankingItem => {
                            rankingPromises.push(renderSeriesRankingItem(rankingItem, rankingItem.position + positionCounts[rankingItem.position] - 1, views['tournament/series/ranking'].$view.clone()));
                        });

                        Promise.all(rankingPromises).then($rankingItems => {
                            $rankingItems.forEach($rankingItem => {
                                STATUS.$view.find('[data-id="seriesRankings"]').append($rankingItem);
                            });
                        });
                    });
                });

                ScoreTrekBattle.Template.render('tournament/details/series', {
                    series: series
                }).then(view => {
                    STATUS.$view.find('[data-id="seriesDetails"]').append(view.$view);

                    STATUS.$view.attr({
                        'data-series-id': series.id,
                        'data-series-is-favorite': series.isFavorite ? 'yes' : 'no'
                    });

                    if (series.description) {
                        STATUS.$view.find('[data-id="description"]').html(__addHyperlinks(__escapeHTML(series.description), 'color-yellow'));
                    } else {
                        STATUS.$view.find('[data-id="descriptionWrapper"]').remove();
                    }
                    if (series.tournamentsCount === series.publicTournamentsCount) {
                        STATUS.$view.find('[data-id="series.hiddenTournaments"]').remove();
                    }

                    resolve();
                });
            }).catch(error => {
                chmDialog.error(error);
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loadingBackground('Tournament.List.updateSeries', false);
            });
        });
    }

    function renderSeriesRankingItem(rankingItem, positionTo, $rankingView) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Tournament.Match.renderTeam(null, {
                id: '',
                name: '',
                participants: [rankingItem.participant]
            }).then($teamView => {
                $rankingView.find('[data-id="position"]').html(`<span class="text-no-wrap">${rankingItem.position}</span>${(positionTo > rankingItem.position) ? `<span style="opacity:0.3;">–<span class="text-no-wrap">${positionTo}</span></span>` : ''}`);
                $rankingView.find('[data-id="team"]').empty().append($teamView);
                $rankingView.find('[data-id="gamesPlayed"]').text(rankingItem.tournamentsCount);
                $rankingView.find('[data-id="pointsWonText"]').text(rankingItem.totalScore);
                $rankingView.attr('data-is-qualified', '');
                resolve($rankingView);
            });
        });
    }


    function updateClub() {
        return new Promise(function(resolve, reject) {
            if (!STATUS.config.clubId) {
                STATUS.$view.find('[data-ref-id="club"]').remove();
                resolve();
                return;
            }

            STATUS.$view.find('[data-tab]').removeClass('isActive');
            STATUS.$view.find('[data-tab="tournament"]').addClass('isActive');
            STATUS.$view.find('[data-tab="tournaments"]').addClass('isActive');

            ScoreTrekBattle.View.loadingBackground('Tournament.List.updateClub', true);

            ScoreTrekBattle.Club.load(STATUS.config.clubId).then(club => {
                ScoreTrekBattle.Club.setCurrent(club);

                ScoreTrekBattle.Template.render('tournament/details/club', {
                    club: club,
                    clubEscaped: ScoreTrekBattle.Club.escape(club),
                    mapsUrl: ScoreTrekBattle.Club.getMapsUrl(club)
                }).then(view => {
                    STATUS.$view.attr({
                        'data-club-id': club.id,
                        'data-club-is-favorite': club.isFavorite ? 'yes' : 'no'
                    });

                    STATUS.$view.find('[data-tab="tournament"]').attr('href', `/club/tournaments/${club.id}`);
                    STATUS.$view.find('[data-tab="tournaments"]').attr('href', `/club/tournaments/${club.id}`);
                    STATUS.$view.find('[data-tab="series"]').attr('href', `/club/series/${club.id}`);
                    STATUS.$view.find('[data-tab="matchdays"]').attr('href', `/club/matchdays/${club.id}`);

                    STATUS.$view.find('[data-id="clubDetails"]').append(view.$view);

                    ['email', 'phone', 'website'].forEach(field => {
                        if (!club[field]) {
                            STATUS.$view.find(`[data-id="club.${field}"]`).remove();
                        }
                    });

                    if (club.tournamentsCount === club.publicTournamentsCount) {
                        STATUS.$view.find('[data-id="club.hiddenTournaments"]').remove();
                    }

                    resolve();
                });
            }).catch(error => {
                ScoreTrekBattle.View.goto('/dashboard').then(() => {
                    setTimeout(() => {
                        chmDialog.error(error);
                    }, 0);
                });
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loadingBackground('Tournament.List.updateClub', false);
            });
        });
    }

    function updateList(tournamentId, isFirstLoad) {
        var isSeries, isClub, isCached;

        isSeries = !!STATUS.config.seriesId;
        isClub = !!STATUS.config.clubId;

        ScoreTrekBattle.View.loadingBackground('Tournament.List.updateList', true);

        STATUS.options = {
            plan: STATUS.config.isPlan,
            status: (isSeries || isClub) ? null : STATUS.config.status,
            finalized: (isSeries || isClub) ? null : STATUS.config.isFinalized,
            seriesId: isSeries ? STATUS.config.seriesId : null,
            isClub: STATUS.config.isClub,
            clubId: isClub ? STATUS.config.clubId : null,
            mine: (isSeries || isClub) ? null : STATUS.config.isMine,
            sort: STATUS.config.sort
        };

        if (STATUS.CURRENT.isStale) {
            resetCacheItem(STATUS.CURRENT);
        }

        isCached = isFirstLoad && (STATUS.CURRENT.items.length > 0);

        STATUS.$list.empty();

        loadList(isFirstLoad).then(resultList => {
            if ((STATUS.fallback === 'fallback:preset.list') && resultList && (resultList.length === 0)) {
                ScoreTrekBattle.View.goto(`/tournament/preset/list`, false, true);
                return;
            }

            return (isCached ? syncList() : Promise.resolve()).then(() => {
                return renderList();
            }).then(hasItems => {
                if (!hasItems && STATUS.$list && (STATUS.$list.children().length === 0)) {
                    renderItem(null).then($item => {
                        STATUS.$list.append($item);
                    });
                    return;
                }

                setFocus(tournamentId || STATUS.focusTournamentId);
                stopObserver();
                startObserver();
            });
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loadingBackground('Tournament.List.updateList', false);
        });
    }

    function loadMore() {
        return new Promise(resolve => {
            if (!STATUS.CURRENT.hasMore) {
                return resolve(false);
            }

            ScoreTrekBattle.View.loadingBackground('Tournament.List.loadMore', true);

            loadList().then(() => {
                renderList().then(() => {
                    resolve(STATUS.CURRENT.hasMore);
                });
            }).catch(() => {
                resolve(false);
            }).finally(() => {
                ScoreTrekBattle.View.loadingBackground('Tournament.List.loadMore', false);
            });
        });
    }

    function loadList(isFirstLoad) {
        return new Promise(function(resolve, reject) {
            let timer;

            if (STATUS.isLoading) {
                timer = setInterval(function() {
                    if (STATUS.isLoading) {
                        return;
                    }
                    clearInterval(timer);
                    loadList(isFirstLoad).then(resolve).catch(reject);
                }, 100);
                return;
            }

            indicateFilters();

            if (isFirstLoad && (STATUS.CURRENT.items.length > 0)) {
                updateHasMore(STATUS.CURRENT.hasMore);

                storeCache();

                return resolve(STATUS.CURRENT.items);
            }

            STATUS.isLoading = true;

            executeLoadList().then(resolve).catch(reject).finally(() => {
                STATUS.isLoading = false;            
            });
        });
    }

    function syncList() {
        let cacheItem;

        cacheItem = STATUS.CURRENT;

        return Api.request('/battle/tournament/listUpdate', {
            options: STATUS.options,
            filters: cacheItem.filters,
            timestamp: cacheItem.timestamp || 0,
            ids: cacheItem.items.map(item => {
                return item.id;
            })
        }).then(result => {
            if (cacheItem !== STATUS.CURRENT) {
                return;
            }

            if (result.reset) {
                resetCacheItem(cacheItem);
                return loadList(true);
            }

            (result.removed || []).forEach(tournamentId => {
                removeCurrentItem(tournamentId);
            });

            (result.list || []).forEach(tournament => {
                removeCurrentItem(tournament.id);
                insertCurrentItem(tournament);
            });

            cacheItem.offset = cacheItem.items.length;
            cacheItem.timestamp = result.timestamp || cacheItem.timestamp;
            cacheItem.now = result.now || cacheItem.now;

            storeCache();
        }).catch(error => {
            console.error(error);
        });
    }

    function removeCurrentItem(tournamentId) {
        let index;

        index = getCurrentItemIndex(tournamentId);

        if (index >= 0) {
            STATUS.CURRENT.items.splice(index, 1);
        }

        return index;
    }

    function insertCurrentItem(tournament) {
        let index;

        index = getInsertIndex(tournament);

        if (index >= 0) {
            STATUS.CURRENT.items.splice(index, 0, tournament);
        } else if (!STATUS.CURRENT.hasMore) {
            STATUS.CURRENT.items.push(tournament);
        }
    }

    function getCurrentItemIndex(tournamentId) {
        return STATUS.CURRENT.items.findIndex(item => {
            return (item.id === tournamentId);
        });
    }

    function getInsertIndex(tournament) {
        return STATUS.CURRENT.items.findIndex(item => {
            return (compareItems(tournament, item) < 0);
        });
    }

    function compareItems(itemA, itemB) {
        let diff;

        diff = (itemA.dateTimeTournamentTimestamp || 0) - (itemB.dateTimeTournamentTimestamp || 0);

        if (diff !== 0) {
            return STATUS.isAscending ? diff : -diff;
        }

        return String(itemA.title || '').toLowerCase().localeCompare(String(itemB.title || '').toLowerCase());
    }

    function addIfNew(tournament) {
        if (!STATUS.CURRENT || !STATUS.CURRENT.items) {
            return false;
        }

        if (getCurrentItemIndex(tournament.id) < 0) {
            addToCurrentCache(tournament);
        }
    }

    function addToCurrentCache(newTournament) {
        let tournamentDate;

        if (!STATUS.CURRENT || !STATUS.CURRENT.items) {
            return false;
        }

        if ((getInsertIndex(newTournament) < 0) && STATUS.CURRENT.hasMore) {
            return false;
        }

        insertCurrentItem(newTournament);

        STATUS.CURRENT.offset = STATUS.CURRENT.items.length;

        tournamentDate = getTournamentDate(newTournament);

        renderItem(newTournament, tournamentDate, STATUS.config.seriesId, STATUS.config.isPlan).then($newTournament => {
            let nextTournament;

            nextTournament = STATUS.CURRENT.items[getCurrentItemIndex(newTournament.id) + 1];

            insertNewItemBeforeExisting($newTournament, nextTournament ? nextTournament.id : '', tournamentDate);
        });

        return true;
    }

    function insertNewItemBeforeExisting($newTournament, existingTournamentId, tournamentDate) {
        let $existingItem, $existingSeparator;
        if (!STATUS.$list) {
            return;
        }

        if (STATUS.isRendering) {
            setTimeout(() => {
                insertNewItemBeforeExisting($newTournament, existingTournamentId, tournamentDate);
            }, 100);
            return;
        }

        $newTournament.hide();

        $existingItem = (existingTournamentId === '') ? [] : STATUS.$list.find(`[data-tournament-id="${existingTournamentId}"]`);

        if ($existingItem.length === 0) {
            STATUS.$list.append($newTournament);
        } else {
            if ($existingItem.attr('data-month') !== $newTournament.attr('data-month')) {
                $existingItem = STATUS.$list.find(`[data-month="${$existingItem.attr('data-month')}"]`).first();
            }

            $existingItem.before($newTournament);
        }

        $existingSeparator = STATUS.$list.find(`[data-month="${tournamentDate.yearMonthText}"].isSeparator`);

        if ($existingSeparator.length === 0) {
            renderMonth(tournamentDate.yearMonthZero, tournamentDate.monthText, tournamentDate.yearText, tournamentDate.yearMonthText).then($separator => {
                $newTournament.before($separator);
            });
        }

        addNowSeparator();

        $newTournament.slideDown();
    }

    function executeLoadList() {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loadingBackground('Tournament.List.loadList', true);

            Api.request('/battle/tournament/list', {
                options: STATUS.options,
                filters: STATUS.CURRENT.filters,
                offset: STATUS.CURRENT.offset
            }).then(result => {
                if (result.list && result.list.length > 0) {
                    STATUS.CURRENT.offset += result.list.length;
                    STATUS.CURRENT.items = STATUS.CURRENT.items.concat(result.list);
                }

                if (result.timestamp) {
                    STATUS.CURRENT.timestamp = result.timestamp;
                }

                if (result.now) {
                    STATUS.CURRENT.now = result.now;
                }

                updateHasMore(!!result.hasMore);

                storeCache();

                resolve(result.list || null);
            }).catch(reject).finally(() => {
                ScoreTrekBattle.View.loadingBackground('Tournament.List.loadList', false);
            });
        });
    }

    function updateHasMore(hasMore) {
        STATUS.CURRENT.hasMore = hasMore;

        if (!STATUS.CURRENT.hasMore) {
            stopObserver();
        }

        if (STATUS.$loadMore) {
            STATUS.$loadMore.css('display', STATUS.CURRENT.hasMore ? '' : 'none');
        }
    }

    function renderList() {
        return new Promise(function(resolve) {
            let newItems;

            STATUS.isRendering = true;

            newItems = STATUS.CURRENT.items.filter(item => {
                return STATUS.$list[0].querySelector(`[data-tournament-id="${item.id}"]`) === null;
            });

            if (newItems.length === 0) {
                return resolve(false);
            }

            renderListItems(newItems, STATUS.config.seriesId, STATUS.config.isPlan, true).then($items => {
                STATUS.$list.append($items);

                addNowSeparator().then(() => {
                    resolve(true);
                });

            }).finally(() => {
                STATUS.isRendering = false;
            });
        });
    }

    function renderListItems(items, seriesId, isPlan, addSeparators, ignoreStatus) {
        return new Promise(function(resolve) {
            var promises, currentYearMonthZero, addedSeparators;

            promises = [];
            currentYearMonthZero = 0;
            addedSeparators = {};

            items.forEach(item => {
                let itemDate;

                if (!checkItemValid(item)) {
                    return;
                }

                itemDate = getTournamentDate(item);

                if (addSeparators && !addedSeparators[itemDate.yearMonthZero] && (itemDate.yearMonthZero !== currentYearMonthZero) && (ignoreStatus || (STATUS.$list[0].querySelector(`[data-separator="${itemDate.yearMonthZero}"]`) === null))) {
                    currentYearMonthZero = itemDate.yearMonthZero;
                    addedSeparators[currentYearMonthZero] = true;
                    promises.push(renderMonth(currentYearMonthZero, itemDate.monthText, itemDate.yearText, itemDate.yearMonthText));
                }

                promises.push(renderItem(item, itemDate, seriesId, isPlan));
            });

            Promise.all(promises).then($items => {
                $items.forEach($item => {
                    if (STATUS.config.isPlan) {
                        $item.find('[data-id="emptyItemLinks"]').remove();
                    }
                });

                resolve($items);
            });
        });
    }

    function addNowSeparator() {
        return new Promise(function(resolve) {
            let beforeNowItem, afterNowItem;

            if (!STATUS.$list) {
                resolve();
            }

            STATUS.$list.find('[data-separator="NOW"]').remove();

            if (STATUS.CURRENT.now && (STATUS.$list.find(`[data-separator="NOW"]`).length === 0)) {
                STATUS.$list.find('[data-separator]').each(function() {
                    let time;
                    time = parseInt(this.dataset.separator, 10) || 0;

                    if (!time) {
                        return;
                    }

                    if (time < STATUS.CURRENT.now) {
                        beforeNowItem = this;
                    }

                    if (time >= STATUS.CURRENT.now) {
                        afterNowItem = this;
                    }

                    if (beforeNowItem && afterNowItem) {
                        return false;
                    }
                });
            }

            if (beforeNowItem && afterNowItem) {
                renderNow().then($item => {
                    if (STATUS.isAscending) {
                        $(afterNowItem).before($item);
                    } else {
                        $(beforeNowItem).before($item);
                    }

                    resolve();
                });

                return;
            }

            resolve();
        });
    }
    function loadSeries() {
        return new Promise(function(resolve, reject) {
            Api.request('/battle/tournament/series/load', {
                id: STATUS.config.seriesId,
                addRanking: true
            }).then(result => {
                if (!result || !result.series) {
                    reject(new Error('SERIES_DOES_NOT_EXIST'));
                }
                resolve(result);
            }).catch(reject);
        });
    }

    function checkItemValid(item) {
        if (!item || !item.clubId || !item.title || !item.dateTimeTournamentTimestamp) {
            return false;
        }
        return true;
    }

    function renderMonth(yearMonthDay, monthText, year, yearMonth) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/listItemMonth', {month: monthText, year: year}).then(view => {
                view.$view.attr({
                    'data-separator': yearMonthDay,
                    'data-month': yearMonth
                });
                resolve(view.$view);
            });
        });
    }

    function renderNow() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/listItemNow').then(view => {
                view.$view.attr('data-separator', 'NOW');
                resolve(view.$view);
            });
        });
    }

    function renderItem(item, itemDate, seriesId, isPlan) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render(item ? 'tournament/listItem' : 'tournament/listItemEmpty', {
                tournament: item,
                tournamentLink: getTournamentLink(item, true),
                itemDate: itemDate,
                config: STATUS.config
            }, true).then(itemView => {
                let hasSeries;

                if (item) {
                    hasSeries = !!(item.series && !seriesId);
                    itemView.$view.toggleClass('hasSeries', hasSeries);
                    itemView.$view.attr({
                        'data-separator': itemDate.yearMonthDay,
                        'data-month': itemDate.yearMonthText
                    });
                    if (!hasSeries) {
                        itemView.$view.find('[data-ref-id="tournamentSeries"]').remove();
                    }
                    if (!item.nextTournamentId) {
                        itemView.$view.find('[data-ref-id="prevTournament"]').remove();
                    }
                    if (!item.isNextTournament) {
                        itemView.$view.find('[data-ref-id="nextTournament"]').remove();
                    }
                    if (!item.pointsMapId) {
                        itemView.$view.find('[data-ref-id="tournamentPointsMap"]').remove();
                    }

                    itemView.$view.find(`[data-ref-id="${isPlan ? 'default' : 'plan'}"]`).remove();
                }
                resolve(itemView.$view);
            });
        });
    }

    function getTournamentLink(item, hashOnly) {
        if (!item) {
            return '';
        }

        return ScoreTrekBattle.Settings.getShareUrl('tournament', item.id, hashOnly);
    }

    function getTournamentDate(item) {
        var dateString, timeString, year, month, day, hour, minute;

        dateString = item ? item.dateTimeTournamentDate : '0000-00-00';
        timeString = item ? item.dateTimeTournamentTime : '00:00';

        year = dateString.substring(0, 4);
        month = dateString.substring(5, 7);
        day = dateString.substring(8, 10);

        hour = timeString.substring(0, 2);
        minute = timeString.substring(3, 5);

        return {
            monthText: __i18n(`date/month/${month}`),
            monthShort: __i18n(`date/month/short/${month}`),
            yearText: `${year}`,
            yearMonthText: `${year}${month}`,
            yearMonthZero: parseInt(`${year}${month}${STATUS.isAscending ? '00' : '99'}${STATUS.isAscending ? '0000' : '9999'}`, 10),
            yearMonthDay: parseInt(`${year}${month}${day}${hour}${minute}`, 10),
            dayText: `${day}`
        };
    }

    function setFocus(tournamentId) {
        STATUS.focusTournamentId = null;

        if (!STATUS.$view) {
            return;
        }

        if (tournamentId) {
            setTimeout(() => {
                AnimationHandler.scrollIntoView(STATUS.$view.find(`[data-tournament-id="${tournamentId}"]`)).then($element => {
                    AnimationHandler.pulse($element);
                }).catch(ignore => {});
            }, 0);
            return;
        }

        if (STATUS.CURRENT.scrollTop) {
            STATUS.isScrolling = true;
            AnimationHandler.scrollTo(STATUS.CURRENT.scrollTop, true).finally(() => {
                STATUS.isScrolling = false;
            });
        }
    }

    function removeFromCache(tournamentId) {
        Object.keys(CACHE).forEach(cacheKey => {
            CACHE[cacheKey].cache.forEach(cacheItem => {
                let deleteIndex;

                deleteIndex = -1;

                cacheItem.items.forEach((item, itemIndex) => {
                    if (item.id === tournamentId) {
                        deleteIndex = itemIndex;
                    }
                });

                if (deleteIndex !== -1) {
                    cacheItem.items.splice(deleteIndex, 1);
                    cacheItem.offset = cacheItem.items.length;
                }
            });
        });

        storeCache();
    }

    function updateInCache(tournamentId, updatedTournament) {
        Object.keys(CACHE).forEach(cacheKey => {
            CACHE[cacheKey].cache.forEach(cacheItem => {
                let updateIndex;

                updateIndex = -1;

                cacheItem.items.forEach((item, itemIndex) => {
                    if (item.id === tournamentId) {
                        updateIndex = itemIndex;
                    }
                });

                if (updateIndex !== -1) {
                    cacheItem.items[updateIndex] = updatedTournament;
                }
            });
        });

        storeCache();
    }

    function addToCache(newTournament, afterTournamentId) {
        Object.keys(CACHE).forEach(cacheKey => {
            CACHE[cacheKey].cache.forEach(cacheItem => {
                let afterIndex;

                afterIndex = -1;

                cacheItem.items.forEach((item, itemIndex) => {
                    if (item.id === afterTournamentId) {
                        afterIndex = itemIndex;
                    }
                });

                if (afterIndex !== -1) {
                    cacheItem.items.splice(afterIndex + 1, 0, newTournament);
                    cacheItem.offset = cacheItem.items.length;
                }
            });
        });

        storeCache();
    }

    _this = {
        focus: function(tournamentId) {
            if (STATUS.isLoading) {
                STATUS.focusTournamentId = tournamentId;

                setTimeout(() => {
                    if (!STATUS.$view) {
                        STATUS.focusTournamentId = null;
                    }
                }, 100);

                return;
            }

            setFocus(tournamentId);
        },
        renderList: function(tournaments, addSeparators) {
            return renderListItems(tournaments, null, false, !!addSeparators, true);
        },
        renderEmptyItem: function() {
            return renderItem(null);
        },
        getCurrentName: function() {
            return (STATUS.$view && STATUS.viewId) ? getShareName() : __i18n('share/name/tournaments');
        },
        getShareHash: function() {
            return (STATUS.$view && STATUS.viewId) ? buildPath() : '/tournament/scheduled';
        },
        update: function(updatedTournament) {
            let $tournament, index, insertIndex;

            updateInCache(updatedTournament.id, updatedTournament);

            if (!STATUS.$list) {
                return;
            }

            $tournament = STATUS.$list.find(`[data-tournament-id="${updatedTournament.id}"]`);
            index = removeCurrentItem(updatedTournament.id);

            if (($tournament.length === 0) || (index < 0)) {
                addIfNew(updatedTournament);
                return;
            }

            insertIndex = getInsertIndex(updatedTournament);

            if ((insertIndex !== index) && ((insertIndex >= 0) || (index !== STATUS.CURRENT.items.length))) {
                $tournament.remove();
                addToCurrentCache(updatedTournament);
                return;
            }

            STATUS.CURRENT.items.splice(index, 0, updatedTournament);

            renderItem(updatedTournament, getTournamentDate(updatedTournament), STATUS.config.seriesId, STATUS.config.isPlan).then($newTournament => {
                $tournament.replaceWith($newTournament);
            });
        },
        remove: function(tournamentId) {
            let $tournament;

            removeFromCache(tournamentId);

            if (!STATUS.$list) {
                return;
            }

            $tournament = STATUS.$list.find(`[data-tournament-id="${tournamentId}"]`);

            $tournament.slideUp(() => {
                $tournament.remove();
            });
        },
        add: function(newTournament, afterTournamentId) {
            let $afterTournament;

            addToCache(newTournament, afterTournamentId);

            if (!STATUS.$list) {
                return;
            }

            $afterTournament = STATUS.$list.find(`[data-tournament-id="${afterTournamentId}"]`);

            if ($afterTournament.length === 0) {
                return;
            }

            renderItem(newTournament, getTournamentDate(newTournament), STATUS.config.seriesId, STATUS.config.isPlan).then($newTournament => {
                $newTournament.hide();
                $afterTournament.after($newTournament);
                $newTournament.slideDown(() => {
                    AnimationHandler.pulse($newTournament);
                });
            });
        }
    };

    ScoreTrekBattle.View.registerRedirect('/series', '/series/tournaments');
    ScoreTrekBattle.View.registerRedirect('/club', '/club/tournaments');
    ScoreTrekBattle.View.register('/tournament/scheduled', function() { return onViewRender('scheduled', false, '', 'scheduled', '/tournament/scheduled', collectPathArgs(arguments)); }, onViewLoad, onViewUpdate, onViewUnload);
    ScoreTrekBattle.View.register('/tournament/running', function() { return onViewRender('running', false, '', 'running', '/tournament/running', collectPathArgs(arguments)); }, onViewLoad, onViewUpdate, onViewUnload);
    ScoreTrekBattle.View.register('/tournament/my', function() { return onViewRender('', true, '', 'my', '/tournament/my', collectPathArgs(arguments)); }, onViewLoad, onViewUpdate, onViewUnload);
    ScoreTrekBattle.View.register('/tournament/history', function() { return onViewRender('sealed', false, '', 'sealed', '/tournament/history', collectPathArgs(arguments)); }, onViewLoad, onViewUpdate, onViewUnload);
    ScoreTrekBattle.View.register('/series/tournaments', function(seriesId) { return onViewRender('series', false, seriesId, `series`); }, onViewLoad, onViewUpdate, onViewUnload);
    ScoreTrekBattle.View.register('/club/tournaments', function(clubId) { return onViewRender('club', false, clubId, `club`); }, onViewLoad, onViewUpdate, onViewUnload);
    ScoreTrekBattle.View.register('/tournament/plan', () => { return onViewRender('plan', false, '', 'plan'); }, onViewLoad, onViewUpdate, onViewUnload);

    ScoreTrekBattle.Event.on('action.tournament.series.readMore', function() {
        toggleReadMore(false);
    });
    ScoreTrekBattle.Event.on('action.tournament.series.readLess', function() {
        toggleReadMore(true);
    });

    ScoreTrekBattle.Event.on('action.club.details', function(event, clubId) {
        ScoreTrekBattle.View.goto(`/club/tournaments/${clubId}`);
    });

    ScoreTrekBattle.Event.on('action.list.filters.reset', function(event) {
        if (!STATUS.$view) {
            return;
        }

        resetFilters();

        toggleFilters(false);
    });

    ScoreTrekBattle.Event.on('action.list.filters.toggle', function(event) {
        if (!STATUS.$view) {
            return;
        }

        toggleFilters(!STATUS.$view.find('[data-id="filters"]').hasClass('isOpen'));
    });

    ScoreTrekBattle.Event.on('window.scrolled', function(event, scrollTop, isDown) {
        if (!STATUS.active) {
            return;
        }

        if (window.JQUERY_IS_ANIMATING) {
            return;
        }

        if (isDown && STATUS.$view && !isFiltersToggleLocked() && isFiltersObstructive()) {
            toggleFilters(false);
        }
    });

    ScoreTrekBattle.Event.on('tournament.updated', function(tournament) {
        let timer;
        timer = setInterval(() => {
            if (STATUS.isRendering) {
                return;
            }

            clearInterval(timer);

            _this.update(tournament);
        }, 100);
    });

    ScoreTrekBattle.Event.on('tournament.deleted', function(tournamentId) {
        let timer;
        timer = setInterval(() => {
            if (STATUS.isRendering) {
                return;
            }

            clearInterval(timer);

            _this.remove(tournamentId);
        }, 100);
    });

    ScoreTrekBattle.Event.on('favorite.changed', function(favoriteType, refId, isFavorite) {
        if (favoriteType !== 'tournament') {
            return;
        }

        Object.keys(CACHE).forEach(cacheKey => {
            CACHE[cacheKey].cache.forEach(cacheItem => {
                cacheItem.items.forEach(item => {
                    if (item.id === refId) {
                        item.isFavorite = isFavorite;
                    }
                });

                if (cacheKey === 'my') {
                    cacheItem.isStale = true;
                }
            });
        });
    });

    return _this;
})();